import { Component, OnInit, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { IRelatoriaCapituloModel } from 'src/app/models/relatoria-capitulo.model';
import { IRelatoriaModel } from 'src/app/models/relatoria.model';
import { RelatoriaService } from 'src/app/services/relatoria.service';
import { IEnumModel } from 'src/app/models/enum.model';
import Swal from 'sweetalert2';
import { ModeloRelatorioService } from 'src/app/services/modelo-relatorio.service';
import { BaseFormComponent } from '../base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { IModeloRelatorioModel } from 'src/app/models/modelo-relatorio.model';
import { ICapituloRelatorioModel } from 'src/app/models/capitulo-relatorio.model';
import { RelatoriaCapituloService } from 'src/app/services/relatoria-capitulo.service';
import { PaaService } from 'src/app/services/paa.service';
import { AuthService } from 'src/app/services/auth.service';
import { EnumTipoDocumentoAprovacao } from 'src/app/models/enum/tipo-documento-aprovacao.enum';
import { SharedService } from "../../../services/shared.service";
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
import { MatTableDataSource } from '@angular/material/table';

export type IModeloRelatoria = {
  modeloRelatorio: IModeloRelatorioModel[] | IModeloRelatorioModel | any;
  modeloRelatorioId: number | any;
  habilitarGerarRelatoria: boolean;
  jaEnviadoAprovacao: boolean;
  status: IEnumModel;
  situacao: IEnumModel;

}

export interface IAnexoRelatoriaModel {
  id: number;
  relatoriaId: number;
  nomeArquivo: string;
}

@Component({
  selector: 'app-relatoria',
  templateUrl: './relatoria.component.html',
  styleUrls: ['./relatoria.component.scss']
})
export class RelatoriaComponent extends BaseFormComponent implements OnInit, OnChanges {
  @Input() aba: number;
  @Input() relatoriaDados: (IRelatoriaCapituloModel[] | IModeloRelatorioModel[] | ICapituloRelatorioModel[]);
  @Input() visualizar: boolean;
  @Input() submit: boolean;
  @Input() dadosObtidos: IRelatoriaModel;
  public tituloDocumento: string = '';
  public tituloModeloRelatorio: string = '';
  @Input() public model: IModeloRelatoria = {} as IModeloRelatoria;
  @Input() modelPagina: any;
  @Input() tipoTrabalhoId: number;
  @Input() obterDados: () => void;
  @Input() public impressao: boolean;
  @Input() tipoTrabalhoRef: number;
  @Input() visualizarRelatoriaHidden: boolean;
  public reprovado: boolean;
  public homologado: boolean;
  public emAprovacao: boolean;
  idTipoTrabalhoPaac: number = 2;
  idTipoTrabalhoPaacEspecial: number = 8;
  idTipoTrabalhoExecucao: number = 15;

  tipoTrabalho: number;

  public salvarDadosPendente = false;

  // ---- Upload da relatoria (anexo) ----
  public podeUploadRelatoria: boolean;
  public dataSourceAnexo = new MatTableDataSource<IAnexoRelatoriaModel>([]);
  public acceptTypes = '.docx,.pdf,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private relatoriaService: RelatoriaService,
    private modeloRelatorioService: ModeloRelatorioService,
    private relatoriaCapituloService: RelatoriaCapituloService,
    private paaService: PaaService,
    private authService: AuthService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    if (!this.tipoTrabalhoRef || this.tipoTrabalhoRef == 0) {
      const path = this.route.routeConfig.path?.toString();
      if (path?.includes('pea')) {
        this.tipoTrabalho = 1;
      }
      else if (path?.includes('paa')) {
        this.tipoTrabalho = 2;
      }
      else if (path?.includes('opa')) {
        this.tipoTrabalho = 3;
      }
      else if (path?.includes('osa-execucao')) {
        this.tipoTrabalho = 15;
      }
      else if (path?.includes('osa')) {
        this.tipoTrabalho = 4;
      }
      else if (path?.includes('planejamento')) {
        this.tipoTrabalho = 7;
      }
    } else {
      this.tipoTrabalho = this.tipoTrabalhoRef;
    }


    this.habilitarGerar();
    this.obterRelatorio();
    this.setarPermissoes();

    if (this.aceitaUploadRelatoria) {
      this.carregarAnexo();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dadosObtidos?.currentValue) {
      this.dadosObtidos = changes.dadosObtidos.currentValue;
      this.atualizarTituloDocumento();
    }

    if (changes.tipoTrabalhoRef?.currentValue !== undefined) {
      this.tipoTrabalho = changes.tipoTrabalhoRef.currentValue;
      this.atualizarTituloDocumento();
      this.setarPermissoes();
      if (this.aceitaUploadRelatoria && !changes.tipoTrabalhoRef.firstChange) {
        this.carregarAnexo();
      }
    }

    if (changes.model?.currentValue !== undefined) {

      this.model = changes.model?.currentValue;
      this.reprovado = this.model?.jaEnviadoAprovacao;
      if (this.model?.situacao?.codigo === 4 || this.model?.status?.codigo === 4) {
        this.homologado = true;
      }

    }
  }

  private atualizarTituloDocumento(): void {
    if (!this.dadosObtidos) {
      this.tituloDocumento = '';
      return;
    }

    if (this.tipoTrabalho === 7) {
      this.tituloDocumento = this.dadosObtidos?.nomeDocumento || '';
      this.tituloModeloRelatorio = (this.dadosObtidos?.modeloRelatorio as any)?.nome || '';
      this.visualizarRelatoriaHidden = false;
    } else {
      this.tituloDocumento = this.dadosObtidos?.nomeDocumento || '';
      this.tituloModeloRelatorio = (this.dadosObtidos?.modeloRelatorio as any)?.nome || '';
    }
  }

  ngDoCheck() {
    if (this.model?.situacao?.codigo === 2 || this.model?.status?.codigo === 2) {
      this.emAprovacao = true;
    }
  }

  public habilitarGerar() {
    //TODO:SOMENTE PAA POR ENQUANTO
    if (this.id && (this.tipoTrabalho == this.idTipoTrabalhoPaac || this.tipoTrabalho == this.idTipoTrabalhoPaacEspecial)) {
      this.relatoriaService.habilitarGerar(this.id, this.tipoTrabalho)
        .then((res) => {
          if (res.sucesso)
            this.model.habilitarGerarRelatoria = res.dados;
        })
    }
  }




  public obterRelatorio() {
    //if (this.relatoriaDados && this.dadosObtidos) { return; }

    if (this.id) {
      this.relatoriaService.obterPorTipoTrabalho(this.id, this.tipoTrabalho)
        .then((res) => {
          if (res.sucesso) {
            // this.relatoriaDados = res.dados.relatoriasCapitulos;
            // this.dadosObtidos = res.dados;
            this.relatoriaService.reltoriaCurrent.subscribe(relatoriaDados => {
              this.relatoriaDados = relatoriaDados?.relatoriasCapitulos;
              this.dadosObtidos = relatoriaDados;

            })

            this.tituloDocumento = this.dadosObtidos?.nomeDocumento || '';
            this.tituloModeloRelatorio = (this.dadosObtidos?.modeloRelatorio as any)?.nome || '';

          }
        }).catch(err => {
          this.exibirMensagemErro(err.mensagem.descricao);
        })
    }

  }

  public async gerar() {

    this.relatoriaService.gerar({
      modeloRelatorioId: (this.model.modeloRelatorio as IModeloRelatorioModel).id,
      tipoTrabalhoId: this.id,
      tipoTrabalho: { codigo: this.tipoTrabalho } as IEnumModel
    } as IRelatoriaModel)
      .then(res => {
        if (res.sucesso) {
          this.exibirMensagemSucesso(res.mensagem.descricao);
          this.obterRelatorio();
          (this.model as any).habilitarEnviarAprovacao = true;
          this.obterDados();
        }
        if (!res.sucesso) {
          this.exibirMensagemErro(res.mensagem.descricao);
        }
      }).catch(err => {
        this.exibirMensagemErro(err.mensagem.descricao);
      })
  }

  public async exibirModalModeloRelatorio() {
    if (this.possuiAnexo) {
      Swal.fire('Atenção', 'Não é possível gerar relatoria, pois já existe arquivo de relatoria anexado.', 'warning');
      return;
    }

    try {
      const res = await this.modeloRelatorioService.obterPorTipoTrabalho(this.tipoTrabalho.toString(), true, true);
      if (res.sucesso) {
        res.dados.sort();
        const modal = this.exibirModal('Selecionar Modelo de Relatório', res.dados);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            this.salvarDadosPendente = true;
            this.model.modeloRelatorio = data;
            this.model.modeloRelatorioId = data.id;
          }
        });
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  public cancelar() {
    if (this.tipoTrabalho == 1)
      this.router.navigate(['/pea']);
    else if (this.tipoTrabalho == this.idTipoTrabalhoPaac || this.tipoTrabalho == this.idTipoTrabalhoPaacEspecial)
      this.router.navigate(['/paa']);
    else if (this.tipoTrabalho == 3)
      this.router.navigate(['/opa']);
    else if (this.tipoTrabalho == 4)
      this.router.navigate(['/osa']);
    else if (this.tipoTrabalho == 7)
      this.router.navigate(['/planejamento']);
  }

  desabilitarBotaoEnviarAprovacao(): boolean {
    if (this.possuiAnexo) {
      return false;
    }

    return this.relatoriaDados == null
      || this.relatoriaDados == undefined
      || this.dadosObtidos.tipoTrabalhoStatus.codigo != 1;
  }

  public async enviarAprovacao() {
    if (this.tipoTrabalho == this.idTipoTrabalhoPaac || this.tipoTrabalho == this.idTipoTrabalhoPaacEspecial) {

      const perfis = await this.authService.obterPerfisSimplificado();
      const inputOptions = new Map;

      perfis.dados.forEach(element => {
        inputOptions.set(element.guid, element.nome)
      });

      Swal.fire({
        title: 'Enviar para aprovação',
        text: 'Selecione seu Perfil de envio para aprovação',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        input: 'select',
        inputOptions,
      }).then(res => {
        if (res.isConfirmed) {
          this.paaService.enviarAprovacao(this.id, res.value.toString())
            .then((res) => {
              if (res.sucesso) {
                if (res.mensagem.codigo === 42 || res.mensagem.codigo === 99) {
                  this.exibirMensagemErro(res.mensagem.descricao);
                  return
                }
                this.exibirMensagemSucesso('PAAC enviado para aprovação.');
                this.router.navigate([`/pendencias`]);
              } else {
                this.exibirMensagemErro(res.mensagem.descricao);
              }
            })
            .catch((err) => {
              this.exibirMensagemErro(err.mensagem.descricao);
            })
        }
      })
    }
  }

  // ==================== Upload da relatoria (anexo) ====================

  private setarPermissoes(): void {
    let recurso: EnumRecursoPerfil = null;

    if (this.tipoTrabalho === 1) {
      recurso = EnumRecursoPerfil.ManterPEA;
    } else if (this.tipoTrabalho === this.idTipoTrabalhoPaac || this.tipoTrabalho === this.idTipoTrabalhoPaacEspecial) {
      recurso = EnumRecursoPerfil.ManterPAA;
    } else if (this.tipoTrabalho === 7) {
      recurso = EnumRecursoPerfil.Planejamento;
    } else if (this.tipoTrabalho === this.idTipoTrabalhoExecucao) {
      recurso = EnumRecursoPerfil.AuditoriaExecucao;
    }

    this.podeUploadRelatoria = recurso
      ? this.authService.possuiPermissao(recurso, EnumAcaoRecurso.UploadRelatoria)
      : false;
  }

  public get possuiCapitulos(): boolean {
    return Array.isArray(this.relatoriaDados) && this.relatoriaDados.length > 0;
  }

  public get relatoriaGeradaPorModelo(): boolean {
    const id = this.dadosObtidos?.modeloRelatorioId;
    return id != null && Number(id) !== 0;
  }

  public get podeExibirUploadRelatoria(): boolean {
    return this.aceitaUploadRelatoria && !this.possuiCapitulos && !this.relatoriaGeradaPorModelo;
  }

  public get aceitaUploadRelatoria(): boolean {
    return this.tipoTrabalho === 1
      || this.tipoTrabalho === this.idTipoTrabalhoPaac
      || this.tipoTrabalho === this.idTipoTrabalhoPaacEspecial
      || this.tipoTrabalho === 7
      || this.tipoTrabalho === this.idTipoTrabalhoExecucao;
  }

  public get possuiAnexo(): boolean {
    return this.dataSourceAnexo?.data?.length > 0;
  }

  public carregarAnexo(): void {
    if (!this.id || !this.tipoTrabalho) { return; }

    this.relatoriaService.obterAnexoPorTipoTrabalho(this.id, this.tipoTrabalho)
      .then(res => {
        if (res?.sucesso && res.dados) {
          this.dataSourceAnexo.data = [res.dados];
        } else {
          this.dataSourceAnexo.data = [];
        }
      }).catch(err => {
        this.exibirMensagemErro(err.mensagem.descricao);
      });
  }

  public async anexarArquivo(e: any) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || files.length === 0) { return; }
    if (this.possuiAnexo) { return; } // regra: apenas um arquivo

    const file = files[0];
    const nome = (file.name || '').toLowerCase();
    const sizeMB = file.size / 1024 / 1024;

    const formatoValido = nome.endsWith('.pdf') || nome.endsWith('.docx');

    if (!formatoValido) {
      Swal.fire('Atenção', 'O arquivo deve estar no formato DOCX ou PDF.', 'warning');
      e.target.value = '';
      return;
    }

    if (sizeMB > 28) {
      Swal.fire('Atenção', 'O arquivo não pode ultrapassar 28MB.', 'warning');
      e.target.value = '';
      return;
    }

    const relatoriaId = this.dadosObtidos?.id ?? this.id;
    const base64 = await this.getBase64(file);

    this.relatoriaService.salvarAnexo({
      tipoTrabalhoId: this.id,
      tipoTrabalho: this.tipoTrabalho,
      nomeArquivo: file.name,
      arquivo: base64.toString()
    }).then(res => {
      if (res.sucesso) {
        this.dataSourceAnexo.data = [res.dados];
        (this.model as any).habilitarEnviarAprovacao = true;
        this.exibirMensagemSucesso(res.mensagem.descricao);
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    }).catch(err => {
      this.exibirMensagemErro(err.mensagem.descricao);
    });

    e.target.value = '';
  }

  public excluirArquivoAnexo(id: number): void {
    this.relatoriaService.excluirAnexo(id).then(res => {
      if (res.sucesso) {
        this.dataSourceAnexo.data = [];
        (this.model as any).habilitarEnviarAprovacao = false;
        this.exibirMensagemSucesso(res.mensagem.descricao);
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    }).catch(err => {
      this.exibirMensagemErro(err.mensagem.descricao);
    });
  }

  public download(element: IAnexoRelatoriaModel): void {
    this.relatoriaService.downloadAnexo(element.id).then((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = element.nomeArquivo;
      a.click();
      window.URL.revokeObjectURL(url);
    }).catch(err => {
      this.exibirMensagemErro(err?.mensagem?.descricao ?? 'Erro ao baixar arquivo.');
    });
  }

  public getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          text: 'Ocorreu um erro ao selecionar o arquivo' + error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        reject(error);
      };
    });
  }

}